<template>
    <div>
        <relationSpellList :game_id="game_id"></relationSpellList>
    </div>
</template>
<script>

import relationSpellList from '@/components/relation/games/spell/list.vue';

export default {
    components: {
        relationSpellList
    },
    data () {
        let self = (window.x = this);
        return {
            game_id: 1,
        }
    },
    methods: {
        demo () {
        },
        // end 
    },
    mounted () {
        // this.getData()
    },
    watch: {},
    computed: {}
}
</script>
